<template>
  <div class="custom-header">
    <span class="icon-block" @click="goBack">
      <van-icon name="arrow-left" />
      <span>返回</span>
    </span>
  </div>
</template>

<script>
export default {
  name: "custom-header",
  props: {
    customBack: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
    goBack() {
      if (this.customBack) {
        this.$emit('onBack');
        return;
      }
      this.$router.go(-1);
    }
  },
};
</script>

<style lang="less">
.custom-header {
  position: absolute;
  top: 0;
  left: 0;
  color: #fff;
  z-index: 99;
  .icon-block {
    display: flex;
    align-items: center;
    cursor: pointer;
    background-image: url(../assets/img/back-bg.png);
    background-size: cover;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    width: 204px;
    height: 73px;
    padding-left: 45px;
    padding-bottom: 6px;
    z-index: 99;
    .van-icon {
      font-size: 24px;
    }
    > span {
      font-size: 28px;
    }
  }
}
</style>

